import { defineComponent as _defineComponent } from 'vue'
import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Feedback',
  props: {
    lessonId: String,
    lessonName: String,
    questionId: String,
    questionTitle: String,
    feedbackModalTitle: {
      type: String,
      required: true,
    },
    feedbackDescription: {
      type: String,
      required: true,
    },
    showRating: {
      type: Boolean,
      default: true,
    },
  },
  setup(__props) {

const props = __props;

  
  const { feedbackIcon, arrowRight } = useIcons()
  const { isSmallerMobileDevice } = useBreakpoint()

  const onClick = () => {
    eventBus.$emit('show-modal', {
      modalContentComponent: 'FeedbackModal',
      cssClass: 'feedback-modal',
      modalTitle: props.feedbackModalTitle,
      modalProps: {
        lessonId: props.lessonId || '',
        lessonName: props.lessonName || '',
        showRating: props.showRating,
        questionId: props.questionId || '',
        questionTitle: props.questionTitle || '',
      },
      modalCloseCallback: (callback: () => void) => {
        if (typeof callback === 'function') callback()
      },
    })
  }

return { __sfc: true,props, feedbackIcon, arrowRight, isSmallerMobileDevice, onClick, SVGRenderer, useIcons, useBreakpoint, eventBus }
}

})